export default "__VITE_ASSET__B$QJHSUg__"